export const ANIMATION_TIME = 300
export const MOBILE_SCREEN_WIDTH = 900
